
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/legal/marketplace-terms-of-service",
      function () {
        return require("private-next-pages/[locale]/legal/marketplace-terms-of-service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/legal/marketplace-terms-of-service"])
      });
    }
  